import { render, staticRenderFns } from "./CruiseDetailStateroom.vue?vue&type=template&id=4a4e4e8e&scoped=true"
import script from "./CruiseDetailStateroom.vue?vue&type=script&lang=js"
export * from "./CruiseDetailStateroom.vue?vue&type=script&lang=js"
import style0 from "./CruiseDetailStateroom.vue?vue&type=style&index=0&id=4a4e4e8e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4e4e8e",
  null
  
)

export default component.exports